__turbopack_context__.v({
  "Checkbox": "EmailCollectionDialog-module-scss-module__g6Tc-G__Checkbox",
  "Description": "EmailCollectionDialog-module-scss-module__g6Tc-G__Description",
  "Dialog": "EmailCollectionDialog-module-scss-module__g6Tc-G__Dialog",
  "Form": "EmailCollectionDialog-module-scss-module__g6Tc-G__Form",
  "Input": "EmailCollectionDialog-module-scss-module__g6Tc-G__Input",
  "Submit": "EmailCollectionDialog-module-scss-module__g6Tc-G__Submit",
  "Title": "EmailCollectionDialog-module-scss-module__g6Tc-G__Title",
});
